<template>
  <div>
    <div class="layout miBcycle">
      <div class="system-setting">
        <!-- 主tab选择 -->
        <div
          class="layout-header-tab"
          style="width: calc(100% - 1.875rem); z-index: 22"
        >
          <template v-for="item in configJs">
            <span
              v-if="!item.isHide"
              @click="tabChange(item)"
              :key="item.id"
              :class="{ active: item.active || item.id === currTab.relativeId }"
              class="tab"
            >{{ item.name }}</span
            >
          </template>
        </div>
        <div style="height: 2.5rem"></div>
        <!-- 副标题 -->
        <div
          v-show="
            currTab.isHide &&
            ['600', '700', '900', '300', '902', '104', '105'].includes(
              currTab.id
            )
          "
          style="
            width: calc(100% - 13.25rem);
            position: fixed;
            z-index: 22;
            background-color: #f0f2f5;
          "
        >
          <div
            v-show="
              currTab.isHide &&
              (currTab.id === '700' ||
                currTab.id === '104' ||
                currTab.id === '105')
            "
            class="wgTpye-breadcrumb"
          >
            <span @click="wgTypeGo(1)" class="cursor">违规处理</span>
            <span>/</span>
            <span class="c0">{{
                currTab.id === '700' ? '违规类型设置' : '品牌报表'
              }}</span>
          </div>
          <div
            v-show="
              currTab.isHide && ['600', '900', '902'].includes(currTab.id)
            "
            class="wgTpye-breadcrumb"
          >
            <span @click="jwglGo(1)" class="cursor">角色管理</span>
            <span>/</span>
            <span class="c0">审核列表</span>
          </div>
        </div>
        <div
          ref="secondTitle"
          v-show="
            currTab.isHide &&
            ['600', '700', '900', '300', '902', '104', '105'].includes(
              currTab.id
            )
          "
          style="height: 2.6875rem"
        ></div>
        <!-- 检索区 - 展示 -->
        <div
          ref="searchBox"
          style="
            width: calc(100% - 1.875rem);
            padding: 1rem;
            position: fixed;
            z-index: 22;
            background-color: #f0f2f5;
            right: 0.625rem;
          "
        >
          <div class="filters-container" style="width: 100%">
            <div class="title" v-show="!currTab.isHide || currTab.showtitle">
              {{ currTab.name }}
              <div style="float: right;margin-right: 1.25rem" v-if="currTab.titleRight">
                <template v-for="item in currTab.titleRight">
                  <component
                    v-show="checkUserAuth(72, item.permissionId)"
                    :is="'v-' + item.type"
                    :key="item.id"
                    :params="item"
                    @illegalOperation="illegalOperation"
                    @addWGType="addWGTypePre"
                    @onAuditList="onAuditList"
                    @addGgtz="addGgtzPre"
                    @addRule="addRulePre"
                    @addReport="addGgtzPre"
                  >
                  </component>
                </template>
              </div>
            </div>
            <!-- 第二层选择 -->
            <div class="sub-tab" v-if="currTab.children">
              <template v-for="item in currTab.children">
                <span
                  @click="subTabChange(item)"
                  :key="item.id"
                  :class="{ active: item.active }"
                  class="tab"
                >{{ item.name }}</span
                >
              </template>
            </div>
            <!-- 检索框部分 -->
            <div class="filters-content flex" v-if="currTab.filters">
              <!-- 检索框部分: 左侧 -->
              <div class="f1 filters-left" v-if="currTab.filters.left">
                <el-form :inline="true" :model="form">
                  <!-- 系统考核-车辆类型 -->
                  <el-form-item label="车辆类型：" v-if="currTab && (currTab.id == '120')">
                    <el-select
                      class="w120px"
                      v-model="system.userBikeType"
                      :disabled="system.disabled"
                      size="small"
                      placeholder="">
                      <el-option
                        :label="item.label"
                        :value="item.value"
                        v-for="item in bikeTypeList"
                        :key="item.value"/>
                    </el-select>
                  </el-form-item>
                  <!-- 考勤日统计-筛选日期查询 -->
                  <el-form-item label="日期：" v-if="currTab && (currTab.id == '1001')">
                    <el-date-picker
                      v-model="clockDay"
                      type="date"
                      class="w130"
                      size="small"
                      placeholder="请选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <!-- 考勤统计-筛选月份查询 -->
                  <el-form-item label="月份：" v-if="currTab && (currTab.id == '1002')">
                    <el-date-picker
                      v-model="clockMonth"
                      type="month"
                      class="w130"
                      size="small"
                      placeholder="选择月">
                    </el-date-picker>
                  </el-form-item>
                  <!-- 巡查统计 -->
                  <el-form-item label="统计类型：" v-if="currTab && (currTab.id == '669')">
                    <el-select v-model="statisticalType" style="width: 150px" size="small" @change="handleBrandIdChange">
                      <el-option
                        :label="item.label"
                        :value="item.key"
                        v-for="item in statisticalTypeOptions"
                        :key="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!--扫一扫巡查日志-->
                  <el-form-item label="巡查时间：" v-if="currTab && currTab.id == '668'">
                    <el-date-picker
                      size="small"
                      style="width: 220px"
                      v-model="inspectionLogDataRange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                  <!--扫一扫巡查统计-->
                  <el-form-item label="巡查日期：" v-if="currTab && currTab.id == '669'">
                    <el-date-picker
                      size="small"
                      style="width: 220px"
                      v-model="statisticalDataRange"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                  <template v-for="item in currTab.filters.left">
                    <component
                      v-if="!item.hide"
                      :ref="item.id"
                      :is="'form-' + item.type"
                      :key="item.id"
                      :params="item"
                      :rowData="rowData"
                      @numsDetele="numsDetelePre"
                      @csi="changeSearchItem"
                      @search="search"
                      @save="save"
                      @reset="reset"
                      @export="onExport"
                      @auditExport="onAuditExport"
                      @lineExport="onLineExport"
                      @installExport="onInstallExport"
                      @rejectExport="onRejectExport"
                      @noLineExport="onNoLineExport"
                      @multmatch="multmatchPre"
                      @shlb_zdgl_pass="shlb_zdgl_pass_pre"
                      @shlb_zdgl_reject="shlb_zdgl_reject_pre"
                      @changeType="changeType"
                    ></component>
                  </template>
                  <!--扫一扫巡查——巡查统计导出-->
                  <el-button v-if="currTab && (currTab.id == '669')" v-show="checkUserAuth(72, 231)" size="small" @click="onInspectionExportBtn">导出</el-button>
                  <!--扫一扫巡查——巡查统日志导出-->
                  <el-button v-else-if="currTab && (currTab.id == '668')" v-show="checkUserAuth(72, 232)" size="small" @click="onInspectionLogExportBtn">导出</el-button>
                  <!--考勤统计-月份汇总-->
                  <span v-if="['1002'].includes(currTab.id)" class="filters-left-clock"
                        style="right: 280px">平均工时：{{ clockCollectObj.monthAvgWorkHours }} 工时</span>
                  <span v-if="['1002'].includes(currTab.id)" class="filters-left-clock"
                        style="right: 150px">打卡人数：{{ clockCollectObj.monthWorkDays }} 人</span>
                  <span v-if="['1002'].includes(currTab.id)"
                        class="filters-left-clock">缺卡：{{ clockCollectObj.monthLoseCardNums }} 次</span>
                  <span v-if="['669'].includes(currTab.id)" class="filters-left-clock"
                        style="right: 280px">总核查车辆数：{{ inspectionObj.scanCheckNum }} 辆</span>
                  <span v-if="['669'].includes(currTab.id)" class="filters-left-clock"
                        style="right: 100px">总超量投放率：{{ inspectionObj.overDeliveryRate }} %</span>
                </el-form>
              </div>
              <!-- 检索框部分: 右侧 -->
              <div class="filters-right" v-if="currTab.filters.right">
                <template v-for="item in currTab.filters.right">
                  <component
                    v-show="checkUserAuth(72, item.permissionId)"
                    :is="'v-' + item.type"
                    :key="item.id"
                    :params="item"
                    @illegalOperation="illegalOperation"
                    @addWGType="addWGTypePre"
                    @onAuditList="onAuditList"
                    @addGgtz="addGgtzPre"
                    @addRule="addRulePre"
                    @addReport="addGgtzPre"
                  >
                  </component>
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- 表格区 -->
        <div
          class="layout-body m16 pagination-bg-white"
          v-if="!currTab.hideTable">
          <!-- 检索区 - 隐藏 -->
          <div :style="{ height: (currTab.id == '1001' || currTab.id == '1002') ? '12rem': searchHeight }"></div>
          <!-- 表格 -->
          <div class="table-container" style="margin-top: 1px;padding-bottom: 10px;">
            <el-button v-if="currTab && (currTab.id == '903')" type="primary" size="small" @click="addClockSite"
                       style="background-color: #3e7878;border-color: #3e7878">设置考勤点
            </el-button>
            <el-button
              v-if="currTab && (currTab.id == '903') && (userSelectAddressData && userSelectAddressData.aggregation==0 && userSelectAddressData.level==2)"
              type="primary" size="small"
              @click="addClockEmployeeConfig"
              style="background-color: #3e7878;border-color: #3e7878">
              人员设置
            </el-button>
            <el-table
              v-if="currTab && (currTab.id == '663' || currTab.id == '667')"
              v-loading.body="tableLoading"
              :data="tableData"
              :max-height="tableViewHeight"
              :style="{ height: tableViewHeight }"
              row-key="id">
              <el-table-column
                v-for="item in staticData[currTab.tableColumnsName].columns"
                :key="item.id"
                :label="item.label"
                :prop="item.prop">
                <template v-slot:default="props">
                                <span v-if="props.column.label === '操作'">
                                  <template v-if="currTab && currTab.tableButtons">
                                    <template
                                      v-if="
                                        (currTab.id == '663' || currTab.id == '667') &&
                                        props.row.istree
                                      "/>
                                    <template v-for="btn in currTab.tableButtons" v-else>
                                      <span
                                        v-show="checkUserAuth(72, btn.permissionId)"
                                        :key="btn.id"
                                        v-if="
                                          (btn.relativeKey &&
                                            String(props.row[btn.relativeKey]) ===
                                              btn.relativeValue) ||
                                          !btn.relativeKey">
                                        <span class="gray" v-if="btn.bLine">｜</span>
                                        <span
                                          @click="onShowDialogFromTableBtn(props.row, btn)"
                                          class="table-btn blue cursor">{{ btn.label }}</span>
                                      </span>
                                    </template>
                                  </template>
                                </span>
                  <span v-else>{{ props.row[props.column.property] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <inspection-table ref="inspectionRef" @summary-selected="handleSummarySelected" v-else-if="currTab && (currTab.id == '669')"
                        :query-params="queryParams"/>
            <w-table
              v-else-if="
              currTab &&
              currTab.permissionId &&
              checkUserAuth(72, currTab.permissionId)"
              ref="table"
              v-loading.body="tableLoading"
              :height="tableViewHeight"
              :data-list="tableData"
              :columns="staticData[currTab.tableColumnsName].columns"
              :pageNo="currTab.pageNum"
              :pageSize="currTab.pageSize"
              :pageSizes="currTab.pageSizes"
              :total="currTab.total"
              @pageNoChange="pageNoChange"
              @pageSizeChange="pageSizeChange"
              :needSelection="currTab.needSelection"
              @selection-change="selectionChange"
              :bPagination="currTab.bPagination"
              :selectInit="currTab.selectInitFn && this[currTab.selectInitFn]"
            >
              <template v-slot:cell="props">
                <span v-if="props.column.label === '序号'">{{
                    props.index + 1 + (currTab.pageNum - 1) * currTab.pageSize
                  }}</span>
                <span v-else-if="props.column.label === '品牌'||props.column.label === '品牌名称'">
                  {{
                    (props.row['brandIds'] || props.row['brandId'])
                      | filterBrandName(brands)
                  }}
                </span>
                <span v-else-if="props.column.label === '处理及时率'">
                  {{
                    !props.row['total']
                      ? '0%'
                      : Math.round(
                        (props.row['timelyTotal'] / props.row['total']) *
                        10000
                      ) /
                      100.0 +
                      '%'
                  }}
                </span>
                <span v-else-if="props.column.label === '合格率'">
                  {{
                    !props.row['total']
                      ? '0%'
                      : Math.round(
                        (props.row['passTotal'] / props.row['total']) * 10000
                      ) /
                      100.0 +
                      '%'
                  }}
                </span>
                <span v-else-if="props.column.label === '手机号码'
                   && (currTab.id == '500' || currTab.id == '800'|| currTab.id == '901'
                  || currTab.relativeId == '500' || currTab.relativeId == '800'|| currTab.relativeId == '901')">
                  {{ props.row["phone"] | hidePhoneNumber }}
                </span>
                <span v-else-if="props.column.label === '品牌公司'">
                  {{ props.row['brandId'] | filterBrandName(brands) }}
                </span>
                <span v-else-if="props.column.label === '类型'">
                  {{
                    props.row['accuseTypes'] | filterAccuseTypes(replyTypeList)
                  }}
                </span>
                <span v-else-if="props.column.label === '任务类型'">
                  {{ props.row['mold'] | filterMoldStatus }}
                </span>
                <span v-else-if="props.column.label === '分类'">
                  {{
                    props.row['examineInfo']
                      ? JSON.parse(props.row['examineInfo']).title
                      : '-'
                  }}
                </span>
                <span v-else-if="props.column.label === '地址'">
                  {{ props.row | getAreaNames(nationalArea) }}
                </span>
                <span v-else-if="props.column.label === '地区'">
                  {{
                    props.row
                      | getAreaNamesByAddress(
                      nationalArea,
                      userLevel,
                      userSelfAreaId
                      )
                  }}
                </span>
                <span v-else-if="props.column.label === '提交人'">
                  {{ props.row['submitName'] || props.row['reportName'] }}
                  <template v-if="props.row['isSupervise'] == 1">
                    <span class="pu">监</span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '审核人'">
                  {{ props.row['checkUserName'] }}
                  <template
                    v-if="
                      props.row['auditLastRole'] &&
                      props.row['auditLastRole'] === 'monitor'
                    "
                  >
                    <span class="pu">管理员</span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '申请人'">
                  {{ props.row['miUsersName'] || props.row['realname'] }}
                  <template v-if="props.row['isInvestigate'] === 0">
                    <span class="pu">普</span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '状态'">
                  <template
                    v-if="
                      ['200', '1000', '1100', '1200', '1300'].includes(
                        String(currTab.id)
                      )
                    "
                  >
                    <span
                      :class="{
                        green:
                          Number(props.row.auditCurrent) === 2 &&
                          Number(props.row.applyStatus) === 0,
                      }"
                    >
                      {{ props.row | filterApplyStationStatus(currTab) }}
                    </span>
                  </template>
                  <template>
                    <span :class="{ red: Number(props.row['status']) === 0 }">
                      {{ props.row['status'] | filterStatus }}
                    </span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '匹配状态'">
                  <!--扫一扫巡查日志-匹配状态-->
                  <template v-if="['668'].includes(currTab.id)">
                    {{ props.row['matchStatus'] | filterInspectionMatchStatus }}
                  </template>
                  <template v-else>
                    {{ props.row['matchStatus'] | filterMatchStatus }}
                  </template>
                </span>
                <span v-else-if="props.column.label === '巡查结果'">
                  <template v-if="['668'].includes(currTab.id)">
                    {{ props.row['inspectionResult'] | filterInspectionResult }}
                  </template>
                </span>
                <span v-else-if="props.column.label === '巡查时间'">
                  {{ props.row['inspectionTime'] | dateFormat('yyyy-MM-dd hh:mm:ss') }}
                </span>
                <span v-else-if="props.column.label === '整改时长'">
                  {{
                    (new Date(props.row['finishTime']) -
                      new Date(props.row['createTime']))
                      | formatTime
                  }}
                </span>
                <span v-else-if="props.column.label === '角色'">
                  <template v-if="['500'].includes(currTab.id)">
                    {{ props.row['maintainGroup'] | filterMaintainGroup }}
                  </template>
                  <template v-else>
                    {{ props.row['group'] | filterGroup }}
                  </template>
                </span>
                <span v-else-if="props.column.label === '考勤打卡'">
                  <template v-if="['901','902'].includes(currTab.id)">
                    {{ props.row['clockStatus'] | filterClockStatus }}
                  </template>
                </span>
                <span v-else-if="props.column.label === '角色类型'">
                  <template v-if="['1001','1002','1003'].includes(currTab.id)">
                    {{ props.row['clockRole'] | filterClockRole }}
                  </template>
                   <template v-else-if="['668'].includes(currTab.id)">
                    {{ props.row['roleType'] | filterInspectionRoleType }}
                  </template>
                </span>
                <span v-else-if="props.column.label === '巡查状态'">
                  <template v-if="['668'].includes(currTab.id)">
                  {{ props.row['recycleSwitch'] | filterRecycleSwitchType }}
                  </template>
                </span>
                <span v-else-if="props.column.label === '起始站点'">
                  {{
                    `${
                      props.row['startSiteName']
                        ? props.row['startSiteName'] : ''
                    }${
                      props.row['startSite']
                        ? '(' + props.row['startSite'] + ')'
                        : ''
                    }`
                  }}
                  <p>
                    {{
                      `地址：${props.row['address'] ? props.row['address'] : '/'}`
                    }}
                  </p>
                  <p class="c025">
                    {{
                      props.row['startTime'] | dateFormat('yyyy-MM-dd hh:mm:ss')
                    }}
                  </p>
                </span>
                <span v-else-if="props.column.label === '结束站点'">
                  {{
                    `${
                      props.row['endSiteName'] ? props.row['endSiteName'] : ''
                    }`
                  }}
                  {{ props.row['endSite'] ? `(${props.row['endSite']})` : '' }}
                  <p>
                    {{
                      props.row['endLon']
                        ? `（E${props.row['endLon']}, N${props.row['endLat']}）`
                        : ''
                    }}
                  </p>
                  <p class="c025">
                    {{
                      props.row['endTime'] | dateFormat('yyyy-MM-dd hh:mm:ss')
                    }}
                  </p>
                </span>
                <span v-else-if="props.column.label === '调度员'">
                  <template
                    v-if="
                      props.row['startUserName'] != props.row['endUserName']
                    "
                  >
                    <span
                      class="blue cursor"
                      @click="showUserInfo(props.row['startUserId'])"
                    >
                      {{ props.row['startUserName'] }}
                    </span>
                    <span
                      @click="showUserInfo(props.row['endUserId'])"
                      class="blue cursor"
                    >
                      {{
                        props.row['endUserName']
                          ? '; ' + props.row['endUserName']
                          : ''
                      }}
                    </span>
                  </template>
                  <template v-else>
                    <span
                      class="blue cursor"
                      @click="showUserInfo(props.row['startUserId'])"
                    >
                      {{ props.row['startUserName'] }}
                    </span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '审核状态'">
                  <span
                    :class="{
                      red: props.row['applyStatus'] === 2,
                      green: props.row['applyStatus'] === 1,
                    }"
                  >
                    {{ props.row['applyStatus'] | filterApplyStatus }}
                  </span>
                </span>
                <span v-else-if="props.column.label === '创建时间'">
                  {{
                    props.row['createTime'] | dateFormat('yyyy-MM-dd hh:mm:ss')
                  }}
                </span>
                <span v-else-if="props.column.label === '平均工时'">
                  <span @click="onDialogClockStatisticsTableBtn(props.row, 1)" style="color: #409eff; cursor: pointer;">
                    {{ props.row['avgWorkHours'] }}
                  </span>
                </span>
                <span v-else-if="props.column.label === '出勤天数'">
                  <span @click="onDialogClockStatisticsTableBtn(props.row, 2)" style="color: #409eff; cursor: pointer;">
                    {{ props.row['workDays'] }}
                  </span>
                </span>
                <span v-else-if="props.column.label === '缺卡次数'">
                  <span @click="onDialogClockStatisticsTableBtn(props.row, 3)" style="color: #409eff; cursor: pointer;">
                    {{ props.row['loseCardNums'] }}
                  </span>
                </span>
                <span v-else-if="props.column.label === '操作'">
                  <template v-if="currTab && currTab.tableButtons">
                    <template v-for="btn in currTab.tableButtons">
                      <span
                        v-show="checkUserAuth(72, btn.permissionId)"
                        :key="btn.id"
                        v-if="
                          (btn.relativeKey &&
                            String(props.row[btn.relativeKey]) ===
                              btn.relativeValue) ||
                          (!btn.relativeKey && !btn.hide)">
                        <span class="gray" v-if="btn.bLine">｜</span>
                        <!--修改考勤站点按钮-->
                        <span v-if="btn.id ==='903-tb-1'"
                              @click="onDialogClockSiteTableBtn(props.row)"
                              class="table-btn blue cursor">{{ btn.label }}
                        </span>
                        <!--查看考勤轨迹按钮-->
                        <span v-else-if="btn.id ==='1003-tb-1'"
                              @click="onDialogClockTrackTableBtn(props.row.id)"
                              class="table-btn blue cursor">{{ btn.label }}
                        </span>
                        <!--考勤日统计——查看详情信息-->
                        <span v-else-if="btn.id ==='1001-tb-1'"
                              @click="onDialogClockStatisticsDayTableBtn(props.row)"
                              class="table-btn blue cursor">{{ btn.label }}
                        </span>
                         <span v-else
                               @click="onShowDialogFromTableBtn(props.row, btn)"
                               class="table-btn blue cursor">{{ btn.label }}
                        </span>
                      </span>
                    </template>
                  </template>
                  <template v-else>
                    <template v-for="btn in currTab.tableButtons">
                      <span
                        v-show="checkUserAuth(72, btn.permissionId)"
                        :key="btn.id"
                        v-if="
                          (btn.relativeKey &&
                            String(props.row[btn.relativeKey]) ===
                              btn.relativeValue) ||
                          (!btn.relativeKey && !btn.hide)">
                        <span class="gray" v-if="btn.bLine">｜</span>
                        <span
                          @click="onShowDialogFromTableBtn(props.row, btn)"
                          class="table-btn blue cursor">{{ btn.label }}</span>
                      </span>
                    </template>
                  </template>
                </span>
                <span v-else>{{ props.row[props.column.property] }}</span>
              </template>
              <template v-slot:respondStatus="{ text }">
                {{
                  {
                    '0': '未响应',
                    '50': '未响应(超时)',
                    '100': '已响应(超时)',
                    '200': '已响应(及时)'
                  }[text]
                }}
              </template>
              <template v-slot:completeStatus="{ text }">
                {{
                  {
                    '0': '待完成',
                    '100': '未完成',
                    '200': '已完成',
                    '250': '异常终止'
                  }[text]
                }}
              </template>
              <template v-slot:respondTime="{row}">
                {{ row.completeDatetime ? calculateDuration(row.createTime, row.completeDatetime) : '-' }}
              </template>
              <template v-slot:TimeoutTime="{row}">
                {{ row.respondDatetime ? calculateDuration(row.createTime, row.respondDatetime) : '-' }}
              </template>
            </w-table>
            <p v-else>您的账户没有权限查看此内容！</p>
          </div>
          <!-- <div>{{configJs}}</div> -->
        </div>
      </div>
    </div>
    <!-- 这里写浮层 一层-->
    <w-dialog
      ref="w-dialog"
      isShowFooter
      :title="dialogTitle"
      :width="miTableBtn.dialogWidth"
      @handleClose="onCloseDialog(1)"
      @handleCloseRight="onCloseDialog(2)"
      @onSure="onSureDialog"
      :isShowCancelBtn="miTableBtn.isShowCancelBtn"
      :isShowSureBtn="miTableBtn.isShowSureBtn"
      :cancelBtnText="miTableBtn.cancelBtnText"
      :sureBtnText="miTableBtn.sureBtnText"
      :class="{ gg: currTab.id === '400' }"
    >
      <template v-slot:content>
        <template v-if="miTableBtn && miTableBtn.showType === 'dialog-form'">
          <el-form :inline="true" :model="form" label-width="7.5rem">
            <el-row>
              <template v-for="item in miTableBtn.children">
                <el-col :span="24" :key="item.key + item.label">
                  <component
                    :ref="item.id"
                    :is="'form-' + item.component"
                    :params="item"
                    :rowData="rowData"
                    @csi="handleDialogFromChange"
                  ></component>
                </el-col>
              </template>
            </el-row>
          </el-form>
        </template>
        <template v-else-if="miTableBtn && miTableBtn.children">
          <template v-for="item in miTableBtn.children">
            <component
              :form.sync="form"
              :is="'v-' + item.component"
              :key="item.key + item.label"
              :params="item"
              :tableData="multipleSelection"
              :rowData="rowData"
            >
            </component>
          </template>
        </template>
      </template>
    </w-dialog>
    <!-- 这里写浮层 二层-->
    <w-dialog
      v-if="sureBtnClickContent"
      ref="w-two-dialog"
      isShowFooter
      :title="sureBtnClickContent.title"
      width="60%"
      @handleClose="onTwoCloseDialog"
      @handleCloseRight="onTwoCloseDialog"
      @onSure="onSureTwoDialog"
      :isShowCancelBtn="sureBtnClickContent.isShowCancelBtn"
      :isShowSureBtn="sureBtnClickContent.isShowSureBtn"
      :cancelBtnText="sureBtnClickContent.cancelBtnText"
      :sureBtnText="sureBtnClickContent.sureBtnText"
    >
      <template v-slot:content>
        <template v-if="sureBtnClickContent.showType === 'dialog-form'">
          <div v-if="sureBtnClickContent && sureBtnClickContent.children">
            <template v-for="item in sureBtnClickContent.children">
              <component
                :ref="item.id"
                :is="'form-' + item.component"
                :key="item.key + item.label"
                :params="item"
                :rowData="rowData"
                @csi="towDialogValueChange"
              ></component>
            </template>
          </div>
        </template>
        <template v-else-if="sureBtnClickContent.showType === 'dialog-text'">
          <template v-if="sureBtnClickContent && sureBtnClickContent.children">
            <template v-for="item in sureBtnClickContent.children">
              <component
                :is="'v-' + item.component"
                :key="item.key + item.label"
                :params="item"
                :rowData="rowData"
              >
              </component>
            </template>
          </template>
        </template>
      </template>
    </w-dialog>
    <w-dialog
      ref="w-examineDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleCloseExport"
      @handleCloseRight="handleCloseExport"
      @onSure="onSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content export-span">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in examineOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——审核-->
    <w-dialog
      ref="w-auditDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleAuditCloseExport"
      @handleCloseRight="handleAuditCloseExport"
      @onSure="onAuditSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="auditIsIndeterminate"
            v-model="auditCheckAll"
            @change="handleAuditCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="auditCheckedCities"
            @change="handleAuditCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in auditOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——画线-->
    <w-dialog
      ref="w-lineDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleLineCloseExport"
      @handleCloseRight="handleLineCloseExport"
      @onSure="onLineSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="lineIsIndeterminate"
            v-model="lineCheckAll"
            @change="handleLineCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="lineCheckedCities"
            @change="handleLineCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in lineOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——安装-->
    <w-dialog
      ref="w-installDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleInstallCloseExport"
      @handleCloseRight="handleInstallCloseExport"
      @onSure="onInstallSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="installIsIndeterminate"
            v-model="installCheckAll"
            @change="handleInstallCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="installCheckedCities"
            @change="handleInstallCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in installOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——已拒绝-->
    <w-dialog
      ref="w-rejectDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleRejectCloseExport"
      @handleCloseRight="handleRejectCloseExport"
      @onSure="onRejectSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="rejectIsIndeterminate"
            v-model="rejectCheckAll"
            @change="handleRejectCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="rejectCheckedCities"
            @change="handleRejectCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in rejectOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——不可画线-->
    <w-dialog
      ref="w-noLineDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleNoLineCloseExport"
      @handleCloseRight="handleNoLineCloseExport"
      @onSure="onNoLineSureExport">
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="noLineIsIndeterminate"
            v-model="noLineCheckAll"
            @change="handleNoLineCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="noLineCheckedCities"
            @change="handleNoLineCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in noLineOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--巡查日志——导出功能-->
    <inspection-log-export-dialog
      ref="inspectionLogRef"
      :query-params="queryParams"/>
    <!--考勤统计月份用户详情-->
    <el-dialog title="考勤统计详情" :visible.sync="clockDialogTableVisible" width="85%">
      <div class="m16 pagination-bg-white device">
        <w-table height="500px"
                 v-loading.body="clockTableLoading"
                 :data-list="clockTableData"
                 :columns="staticData.user_clock_info.columns"
                 :pageNo="clockFormData.pageNum"
                 :pageSize="clockFormData.pageSize"
                 :total="clockTotal"
                 @pageNoChange="clockPageNoChange"
                 @pageSizeChange="clockPageSizeChange">
          <template slot-scope="props" slot="cell">
            <span v-if="props.column.label === '序号'">
              {{ props.index + 1 + (clockFormData.pageNum - 1) * clockFormData.pageSize }}
            </span>
            <div v-else-if="props.column.label === '用户名'">
              <div>{{ props.row.name }}
              </div>
            </div>
            <div v-else-if="props.column.label === '品牌名称'">
              <div>{{ props.row['brandId'] | filterBrandName(brands) }}
              </div>
            </div>
            <div v-else-if="props.column.label === '平均工时'">
              {{ props.row.sumWorkHours }}
            </div>
            <div v-else-if="props.column.label === '上班打卡时间'">
              <div class="table-line">
                {{ props.row.startTime }}
              </div>
            </div>
            <div v-else-if="props.column.label === '上班打卡地点'">
              {{ props.row.startSite }}
            </div>
            <div v-else-if="props.column.label === '下班打卡时间'">
              <div class="table-line">
                {{ props.row.endTime }}
              </div>
            </div>
            <div v-else-if="props.column.label === '下班打卡地点'">
              {{ props.row.endSite }}
            </div>
            <div v-else-if="props.column.label === '创建时间'">
              <div class="table-line">
                {{ props.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss') }}
              </div>
            </div>
            <span v-else>{{ props.row[props.column.property] }}</span>
          </template>
        </w-table>
      </div>
    </el-dialog>
    <!--新增考勤站点start-->
    <div class="my_content_box">
      <div class="my_mask" v-show="dialogAddSiteVisible"></div>
      <div class="my_new_site_dialog" v-show="dialogAddSiteVisible">
        <div class="my_new_site_dialog_title">
          <div>新增考勤站点</div>
          <div style="cursor: pointer;padding-top: 0.125rem;" @click="closeAddClockSite">
            <img style="width: 1.5625rem;height: 1.5625rem" src="@/assets/sign.png" alt=""/>
          </div>
        </div>
        <div id="newSiteMap"></div>
        <div class="right_box">
          <div class="right_box_item">
            <div class="right_box_item_label">考勤站点名称:</div>
            <div class="right_box_item_value">
              <el-input style="width: 13.4375rem" v-model="clockSiteName" size="mini"
                        placeholder="请输入考勤站点名称">
              </el-input>
            </div>
          </div>
          <div class="right_box_item">
            <div class="right_box_item_label">品牌名称:</div>
            <div class="right_box_item_value">
              <el-select class="w120px" v-model="clockBrandId" size="small" placeholder="">
                <el-option :label="item.brandName" :value="item.brandId" v-for="item in companyBrandList"
                           :key="'company'+item.brandId"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="handle_btns">
          <el-button size="small" type="primary" @click="onAddClockSite"
                     style="background-color: #3e7878;border-color: #3e7878">添加
          </el-button>
          <el-button size="small" type="primary" @click="closeAddClockSite">取消</el-button>
        </div>
      </div>
    </div>
    <!--查看轨迹回放start-->
    <div class="my_content_box">
      <div class="my_mask" v-show="dialogClockTrackVisible"></div>
      <div class="my_new_site_dialog" v-show="dialogClockTrackVisible">
        <div class="my_new_site_dialog_title">
          <div>查看轨迹线路</div>
          <div style="cursor: pointer;padding-top: 0.125rem;" @click="closeClockTrack">
            <img style="width: 1.5625rem;height: 1.5625rem" src="@/assets/sign.png" alt=""/>
          </div>
        </div>
        <div id="clockTrackMap"></div>
        <div class="input-card" style="margin-top: 0.625rem">
          <el-button type="primary" size="small" @click="startAnimation">开始动画</el-button>
          <el-button type="primary" size="small" @click="pauseAnimation">暂停动画</el-button>
          <el-button type="primary" size="small" @click="resumeAnimation">继续动画</el-button>

        </div>
        <div class="right_box">
          <div class="right_box_item">
            <div class="right_box_item_label">姓名:</div>
            <div class="right_box_item_value">
              <el-input style="width: 12.875rem" v-model="clockTrackUserName"
                        size="mini" :disabled="true">
              </el-input>
            </div>
          </div>
          <div class="right_box_item">
            <div class="right_box_item_label">日期:</div>
            <div class="right_box_item_value">
              <el-input style="width: 12.875rem" v-model="clockTrackDate" size="mini" :disabled="true">
              </el-input>
            </div>
          </div>
          <div class="right_box_item">
            <div class="right_box_item_label">品牌名称:</div>
            <div class="right_box_item_value">
              <el-select class="width: 13.4375rem" v-model="clockTrackBrandId" disabled size="small"/>
            </div>
          </div>
        </div>
        <div class="handle_btns">
          <el-button size="small" type="primary" @click="closeClockTrack">取消</el-button>
        </div>
      </div>
    </div>
    <!--查看轨迹回放end-->
    <!--考勤打卡人员设置-->
    <clock-person-set-dialog ref="clockPersonSetDialog"/>
    <!--考勤打卡-日统计详细-->
    <clock-dialog ref="clockDayDetailDialog"/>
  </div>
</template>

<script>
// 公用
import Api from '@/api'
import configJs from './miBicycle'
// 公共组件
import WDialog from '@/components/Model/index.vue'
import WTable from '@/components/Table/index.vue'
// form 组件
import formButton from './components/form-button'
import formData from './components/form-data'
import formDataRange from './components/form-dataRange'
import formDataTime from './components/form-dataTime'
import formDateselect from './components/form-dateselect'
import formDataTimeRange from './components/form-dataTimeRange'
import formInput from './components/form-input'
import formAutocomplete from './components/form-autocomplete'
import formTextarea from './components/form-textarea'
import formSelect from './components/form-select'
import formStatictext from './components/form-statictext'
import formArea from './components/form-area'
import formAreaArea from './components/form-areaArea'
import formRadio from './components/form-radio.vue'
import formUpload from './components/form-upload.vue'
// 纯展示类组件
import vButton from './components/v-button'
import vText from './components/v-text'
import vTitle from './components/v-title'
import vGgContent from './components/v-gg-content'
import vGgInfo from './components/v-gg-info'
import vSteps from './components/v-steps'
import vImage from './components/v-image'
import vSelect from './components/v-select.vue'
import vTable from './components/v-table.vue'
import vStatictext from './components/v-statictext'
import clockDialog from './components/clock/clockDayDetail-dialog.vue'
import clockPersonSetDialog from './components/clock/clockPersonSetting-dialog.vue'
// vue应用
import { mapGetters } from 'vuex'
import staticData from './staticData.js'
import filters from './filters.js'
// mixins
import dialogLogic from './mixins/dialogLogic.js'
import weigType from './mixins/weigType.js'
import jsgl from './mixins/jsgl.js'
import zdsq from './mixins/zdsq.js'
import inspectionTable from '@/views/InspectionManagement/inspection-table.vue'
import inspectionLogExportDialog from '@/views/InspectionManagement/components/inspectionLogExport-dialog.vue'
// 模拟数据
// import wgjbMockData from './mock/wgjb.json'
import store from '../../store'
import { compare, downloadExcel, getFilterParams, filterMiImage, dateFormat } from '@/utils/tools'
var map = null
var _this = null
export default {
  name: 'miBic',
  mixins: [dialogLogic, weigType, jsgl, zdsq],
  filters,
  data() {
    return {
      searchHeight: '11.9375rem',
      configJs: undefined, // configJs // 在这里设置有缓存
      form: {},
      tableLoading: false,
      subTabName: 'scondKey',
      multipleSelection: [], // 当前table的已选项，当js数据当needSelection为true时使用
      tableViewHeight: '',
      // 系统考核导出
      examineOptions: [
        {
          key: 1,
          label: '序       号'
        },
        {
          key: 2,
          label: '位       置'
        },
        {
          key: 3,
          label: '任务编码'
        },
        {
          key: 4,
          label: '品       牌'
        },
        {
          key: 5,
          label: '任务类型'
        },
        {
          key: 6,
          label: '创建时间'
        },
        {
          key: 7,
          label: '响应状态'
        },
        {
          key: 8,
          label: '响应时间'
        },
        {
          key: 9,
          label: '响应时长'
        },
        {
          key: 10,
          label: '完成状态'
        },
        {
          key: 11,
          label: '完成时间'
        },
        {
          key: 12,
          label: '完成时长'
        },
        {
          key: 13,
          label: '超时时间'
        },
        {
          key: 14,
          label: '站点编号'
        },
        {
          key: 15,
          label: '车辆编号'
        }
      ],
      checkedCities: [],
      isIndeterminate: true,
      checkAll: false,
      // 站点申请-审核
      auditCheckedCities: [],
      auditIsIndeterminate: true,
      auditCheckAll: false,
      auditOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '申请人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '申请时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '审核人'
        },
        {
          key: 9,
          label: '审核时间'
        }
      ],
      // 站点申请-画线
      lineCheckedCities: [],
      lineIsIndeterminate: true,
      lineCheckAll: false,
      lineOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '审核人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '审核时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '画线人'
        },
        {
          key: 9,
          label: '画线时间'
        }
      ],
      // 站点申请-安装
      installCheckedCities: [],
      installIsIndeterminate: true,
      installCheckAll: false,
      installOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '画线人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '画线时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '安装人'
        },
        {
          key: 9,
          label: '安装时间'
        }
      ],
      // 站点申请-已拒绝
      rejectCheckedCities: [],
      rejectIsIndeterminate: true,
      rejectCheckAll: false,
      rejectOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '申请人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '申请时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '审核人'
        },
        {
          key: 9,
          label: '审核时间'
        }
      ],
      // 站点申请-不可画线
      noLineCheckedCities: [],
      noLineIsIndeterminate: true,
      noLineCheckAll: false,
      noLineOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '审核人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '审核时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '画线人'
        },
        {
          key: 9,
          label: '画线时间'
        }
      ],
      clockSiteName: '', // 考勤站点名称
      clockSiteLat: '', // 考勤站点纬度
      clockSiteLon: '', // 考勤站点经度
      nearBySite: [], // 附近的虚拟站点
      dialogAddSiteVisible: false, // 考勤站点信息弹框显示与隐藏
      clockBrandId: '', // 考勤站点品牌Id
      clockSiteInfo: {}, // 考勤站点信息对象
      clockSiteStatus: 0, // 操作考勤站点信息标识 0：未操作 1:新增 2：修改
      clockDay: this.dayjs(new Date()).format('YYYY-MM-DD'), // 考勤日统计-日期
      clockMonth: this.dayjs(new Date()).format('YYYY-MM'), // 考勤月统计-月份
      clockDialogTableVisible: false,
      clockFormData: {
        pageNum: 1,
        pageSize: 20
      },
      clockPageSizes: [10, 20, 50],
      clockTotal: 0,
      clockTableLoading: false,
      clockTableData: null,
      clockCollectObj: {
        dayWorkNums: 0,
        dayLoseCardNums: 0,
        monthAvgWorkHours: 0,
        monthWorkDays: 0,
        monthLoseCardNums: 0
      },
      clockTrackUserName: '', // 轨迹回放用户姓名
      clockTrackBrandId: '', // 轨迹回放品牌Id
      clockTrackDate: '', // 轨迹回放日期
      dialogClockTrackVisible: false, // 轨迹回放信息弹框显示与隐藏
      clockTrackMap: null, // 高德地图实例
      lineArr: [], // 轨迹数据
      clockTrackMarker: null,
      polyline: null,
      duration: 500, // 轨迹回放时间
      formInline: {},
      statisticalTypeOptions: [{
        key: 1,
        label: '企业'
      }, {
        key: 2,
        label: '人名'
      }],
      statisticalType: 1,
      statisticalDataRange: [this.dayjs(new Date().setDate(new Date().getDate() - 10)).format('YYYY-MM-DD'),
        this.dayjs(new Date()).format('YYYY-MM-DD')],
      queryParams: {},
      inspectionObj: {
        scanCheckNum: 0,
        overDeliveryRate: 0
      },
      inspectionLogDataRange: [this.dayjs(new Date().setDate(new Date().getDate() - 10)).format('YYYY-MM-DD'),
        this.dayjs(new Date()).format('YYYY-MM-DD')],
      system: {
        userBikeType: '', // 系统考核——车辆类型
        disabled: true
      },
      bikeTypeList: [
        { value: '', label: '全部' },
        { value: 0, label: '自行车' },
        { value: 1, label: '电动车' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'selfAreaId',
      'permissions',
      'brands',
      'user',
      'areaAll',
      'dispatcherList',
      'replyTypeList',
      'nationalArea',
      'userLevel',
      'userSelfAreaId',
      'userSelectAddressData',
      'tableDataBrands',
      'userBikeType'
    ]),
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    },
    staticData() {
      return staticData
    },
    isAggregation() {
      // 是否是非复合区下的实体区
      return !(
        (this.aggregation == 0 && this.aggregationId == '') ||
        (this.aggregation == 1 && this.aggregationId)
      )
    },
    currTab() {
      return this.configJs.find((item) => item.active)
    },
    tableData() {
      return this.currTab.tableData
    },
    companyBrandList() {
      const companyBrandDate = JSON.parse(JSON.stringify(this.tableDataBrands))
      companyBrandDate.unshift({
        brandName: '全部',
        brandId: ''
      })
      return companyBrandDate
    }
  },
  created() {
    this.configJs = JSON.parse(JSON.stringify(configJs))
    this.getAllDispatcherList()
    this.getReplyTypeList()
    if (this.$route.params && this.$route.params.site) {
      this.tabChange(this.configJs[12])
    }
    if (this.$route.params && this.$route.params.role) {
      console.log(this.$route.params.role)
      this.tabChange(this.configJs[this.$route.params.role])
    }
    const currTab = this.configJs.find((item) => item.active)
    // 系统考核
    this.resetSystemData(currTab.id)
  },
  mounted() {
    this.initData(this.getSearchParams())
    this.calcView()
    this.initMap()
    this.initClockTrackMap() // 初始化轨迹回放地图
  },
  methods: {
    // 系统考核
    resetSystemData(id) {
      if (id === '120' || id === '120-s-9') {
        if (this.userBikeType === 2) {
          this.system.userBikeType = ''
          this.system.disabled = false
        } else {
          this.system.userBikeType = this.userBikeType
          this.system.disabled = true
        }
      }
    },
    handleBrandIdChange(val) {
      this.statisticalType = val
    },
    handleSummarySelected(val) {
      this.inspectionObj = { ...val }
    },
    // 巡查统计-导出功能
    onInspectionExportBtn() {
      this.$refs.inspectionRef.handleInspectionExport(this.queryParams)
    },
    // 巡查日志-导出功能
    onInspectionLogExportBtn() {
      this.$refs.inspectionLogRef.onExport(this.queryParams)
    },
    calculateDuration(startTimeStr, endTimeStr) {
      // 将时间字符串转换为 Date 对象
      const startTime = new Date(startTimeStr)
      const endTime = new Date(endTimeStr)
      // 计算时间差（单位为毫秒），取绝对值，避免负值
      const durationInMs = Math.abs(endTime - startTime)
      // 计算天数、小时、分钟和秒数
      const days = Math.floor(durationInMs / (1000 * 60 * 60 * 24))
      const hours = Math.floor((durationInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((durationInMs % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((durationInMs % (1000 * 60)) / 1000)
      // 构造显示字符串
      let result = ''
      if (days > 0) {
        result += `${days}天`
      }
      result += `${hours}时${minutes}分${seconds}秒`
      // 返回结果
      return result
    },
    // 计划视图区域
    calcView() {
      if (this.$refs.secondTitle) {
        this.$nextTick(() => {
          let H = 40
          if (this.$refs.secondTitle && this.$refs.secondTitle.clientHeight) {
            H += Number(this.$refs.secondTitle.clientHeight)
          }
          if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
            H += Number(this.$refs.searchBox.clientHeight)
          }
          // console.log('H', H)
          // 56: 导航栏高度修正
          // 79: table分页器高度修正
          // px 转为rem
          if (window.innerWidth <= 1920) {
            this.tableViewHeight = (window.innerHeight - 56 - H - 80)
            this.searchHeight = (this.$refs.searchBox.clientHeight - 16) / 16 + 'rem'
          } else { // 2k屏幕自适应
            this.tableViewHeight = (window.innerHeight - 56 - H - 160)
            this.searchHeight = (this.$refs.searchBox.clientHeight - 76) / 16 + 'rem'
          }
        })
      }
    },
    // 表格处理
    pageNoChange(page) {
      const currTab = this.configJs.find((item) => item.active)
      currTab.pageNum = page
      this.refreshPage(currTab)
    },
    pageSizeChange(size) {
      const currTab = this.configJs.find((item) => item.active)
      currTab.pageSize = size
      this.refreshPage(currTab)
    },
    selectionChange(e) {
      console.log(e)
      this.multipleSelection = []
      if (
        this.currTab.name === '扫一扫巡查' ||
        this.currTab.name === '嗅探巡查'
      ) {
        this.multipleSelection = e
        return
      }
      if (e && e.length) {
        e.forEach((item) => {
          this.multipleSelection.push(item.id)
        })
      }
    },
    handleDialogFromChange(e) {
      // console.log('handleDialogFromChange', e)
    },
    shlb_zdgl_selectInitFn(e) {
      if (Number(e.applyStatus) === 0) {
        return true
      }
      return false
    },
    // Api处理区
    initData(sd) {
      const vm = this
      if (
        vm.currTab.permissionId &&
        !vm.checkUserAuth(72, vm.currTab.permissionId)
      ) {
        console.log('没有列表权限，', vm.currTab)
        return
      }
      vm.tableLoading = true
      let params = {}
      if (this.currTab.id === '660' || this.currTab.id === '665') {
        params.matchStatus = 3 // 匹配成功列表默认是3
      }
      params.selfAreaId = this.selfAreaId
      params.currentPage = this.currTab.pageNum
      params.pageSize = this.currTab.pageSize
      if (vm.currTab.id === '120') {
        const currentDate = new Date()
        // 设置开始时间为今天的前两天，并将时分秒设置为 0
        const startDate = new Date(currentDate)
        startDate.setDate(currentDate.getDate() - 2)
        startDate.setHours(0, 0, 0) // 设置时分秒为0
        // 格式化开始时间
        params.startTime = dateFormat(startDate, 'yyyy-MM-dd hh:mm:ss')
        // 设置结束时间为今天，并将时分秒设置为 23:59:59
        const endDate = new Date(currentDate)
        endDate.setHours(23, 59, 59) // 设置时分秒为23:59:59
        // 格式化结束时间
        params.endTime = dateFormat(endDate, 'yyyy-MM-dd hh:mm:ss')
      }
      if (sd) {
        params = Object.assign(params, sd)
        if (params.matchStatus === 123) {
          delete params.matchStatus
        }
      }
      // 扫一扫巡查统计、巡查日志
      if (this.currTab.id === '669' || this.currTab.id === '668') {
        this.queryParams = { ...params }
      }
      Api.fetchApiGet(params, this.currTab.api).then((res) => {
        if (res.code === 200) {
          const currTab = this.configJs.find((item) => item.active)
          if (this.currTab.initTranslate) {
            this.initTranslate(res.data)
          }
          // 考勤统计
          if (currTab.id === '1002') {
            this.$set(currTab, 'tableData', res.data ? res.data.pageInfo.list : [])
            this.$set(currTab, 'total', res.data ? res.data.pageInfo.total : 0)
            this.clockCollectObj.monthWorkDays = res.data.workDays
            this.clockCollectObj.monthAvgWorkHours = res.data.avgWorkHours ? res.data.avgWorkHours : 0
            this.clockCollectObj.monthLoseCardNums = res.data.loseCardNums
            vm.tableLoading = false
            return
          }
          if (res.data && !res.data.list) {
            if (currTab.id === '104' || currTab.id === '105') {
              const aa = res.data.reduce(
                (pre, cur) => {
                  pre.dealTotal += cur.dealTotal
                  pre.notDealTotal += cur.notDealTotal
                  pre.notTimelyTotal += cur.notTimelyTotal
                  pre.passTotal += cur.passTotal
                  pre.timelyTotal += cur.timelyTotal
                  pre.total += cur.total
                  return pre
                },
                {
                  dealTotal: 0,
                  notDealTotal: 0,
                  notTimelyTotal: 0,
                  passTotal: 0,
                  timelyTotal: 0,
                  total: 0
                }
              )
              res.data.push({
                ...{
                  title: '总体情况',
                  id: 0
                },
                ...aa
              })
            } else if (currTab.id == '663' || currTab.id == '667') {
              console.log(666, res.data)
              const bikes = this.brands.map((val, index) => {
                return {
                  brandName: val.brandName,
                  brandId: val.brandId,
                  id: val.brandId,
                  istree: true,
                  children: []
                }
              })
              res.data.forEach((val) => {
                for (const brand of bikes) {
                  if (val.brandId == brand.brandId) {
                    val.brandName = ''
                    brand.children.push(val)
                  }
                }
              })
              res.data = bikes.filter((val) => {
                return val.children.length > 0
              })
            }
            this.$set(currTab, 'tableData', res.data)
            if (currTab.id == 903) {
              this.$set(this.rowData, 'time', res.data)
            } else if (currTab.id == 664) {
              this.rowData = res.data
            }
          } else {
            this.$set(currTab, 'tableData', res.data ? res.data.list : [])
            this.$set(currTab, 'total', res.data ? res.data.total : 0)
          }
          vm.calcView()
        } else {
          vm.$message.warning(res && res.message)
        }
        vm.tableLoading = false
      })
    },
    // 待画线 ：
    // auditCurrent === 3 && applyStatus === 0 && auditLastCurrent === -1 && auditLastUsersId === user.id
    // 已拒绝：
    // auditCurrent === 2 && applyStatus === 3 && auditLastCurrent === -1 && auditLastUsersId === user.id
    initTranslate(data) {
      if (data && data.list) {
        data.list.forEach((item) => {
          if (
            (Number(item.auditCurrent) === 3 &&
              Number(item.applyStatus) === 0 &&
              Number(item.auditLastCurrent) === -1 &&
              Number(item.auditLastUsersId) === Number(this.user.id)) ||
            (Number(item.auditCurrent) === 2 &&
              Number(item.applyStatus) === 3 &&
              Number(item.auditLastCurrent) === -1 &&
              Number(item.auditLastUsersId) === Number(this.user.id))
          ) {
            this.$set(item, 'hasReturn', '1')
          }
        })
      }
    },
    // 搜索处理区
    // 获取默认搜索项
    getSearchDefaultParams(id) {
      const params = {}
      const currTab = this.configJs.find((item) => item.id === String(id))
      if (currTab && currTab.filters && currTab.filters.left) {
        currTab.filters.left.forEach((item) => {
          if (item.dValue) {
            params[item.key] = item.dValue
          }
        })
      }
      return params
    },
    // 获取当前搜索项
    // 给查询按钮使用，处理当前页面的逻辑，切换页面有问题
    getSearchParams() {
      let params = {}
      const currTab = this.configJs.find((item) => item.active)
      currTab.pageNum = 1
      currTab.pageSize = currTab.defaultPageSize
      const refs = this.$refs
      for (const key in refs) {
        const vCom = refs[key] ? refs[key][0] : refs[key]
        if (
          vCom &&
          vCom.getValue &&
          (vCom.getValue() || vCom.getValue() === 0)
        ) {
          console.log(vCom.getValue(), 1)
          params = Object.assign(params, vCom.getValue())
        }
      }
      // 考勤日统计-日期传值
      if (currTab.id === '1001') {
        // 日常值守-待处理事件中运维员预警-跳转到考勤统计日统计
        if (this.$route.name === 'miBicycle' && this.$route.params.clockWarn) {
          this.clockDay = this.$route.params.dateFormat
          params.clockRole = 1
          // 跳转后携带参数设置失效
          this.$route.params.clockWarn = false
        }
        const clockDay = new Date(this.clockDay)
        const year = clockDay.getFullYear()
        // 月份需要加1，然后补足两位
        const month = String(clockDay.getMonth() + 1).padStart(2, '0')
        // 获取日期，确保是两位数
        const day = clockDay.getDate().toString().padStart(2, '0')
        const dayDate = `${year}-${month}-${day}`
        params.dateFormat = dayDate
      }
      // 考勤月统计-月份传值
      if (currTab.id === '1002') {
        const clockMonth = new Date(this.clockMonth)
        const year = clockMonth.getFullYear()
        // 月份需要加1，然后补足两位
        const month = String(clockMonth.getMonth() + 1).padStart(2, '0')
        const monthDate = `${year}-${month}`
        params.monthDate = monthDate
      }
      /// 扫一扫巡查日志、巡查统计
      if (currTab.id === '668' || currTab.id === '669') {
        const dateRange = currTab.id === '668' ? this.inspectionLogDataRange : this.statisticalDataRange
        const { startTime, endTime } = this.getDateRange(dateRange)
        params.inspectionStartTime = startTime
        params.inspectionEndTime = endTime
        if (currTab.id === '669') {
          params.statisticalType = this.statisticalType
        }
      }
      // 系统考核
      if (currTab.id === '120') {
        params.userBikeType = this.system.userBikeType
      }
      return params
    },
    getDateRange(dateRange) {
      return {
        startTime: this.dayjs(dateRange[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.dayjs(dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
    },
    // 给切换页面使用，根据js处理数据
    asyncGetSearchParams(currId) {
      const params = {}
      const curr = this.configJs.find((item) => item.id === String(currId))
      if (curr && curr.filters && curr.filters.left) {
        curr.filters.left.forEach((item) => {
          if (['select', 'input', 'data'].includes(item.type)) {
            if (!!item.value || item.value === 0) {
              params[item.key] = item.value
            }
          } else if (item.type === 'dataRange') {
            if (currId === '668') {
              params.inspectionStartTime = item.start
              params.inspectionEndTime = item.end
            } else {
              if (item.start) {
                params.start = item.start
              }
              if (item.end) {
                params.end = item.end
              }
            }
          } else if (item.type === 'dateselect') {
            params.startTime = this.dayjs(item.dValue)
              .startOf('M')
              .format('YYYY-MM-DD HH:mm:ss')
            params.endTime = this.dayjs(item.dValue)
              .endOf('M')
              .format('YYYY-MM-DD HH:mm:ss')
          }
        })
      }
      return params
    },
    save(target) {
      if (this.isAggregation) {
        this.$message.warning('复合区子区域无法添加，请在复合区添加！')
        return
      }
      // 保存违规处理时间
      const vm = this
      const data = this.getSearchParams()
      const params = {
        selfAreaId: vm.selfAreaId
      }
      // console.log(target);
      Api.fetchApiPost(data, params, target.api)
        .then((res) => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success(
              target.parentId == 664
                ? '时间设置保存成功！'
                : '设置违规时间成功！'
            )
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('saveTime', err)
        })
    },
    search(target) {
      const params = this.getSearchParams()
      console.log('search', target, params)
      this.clearData()
      this.initData(params)
    },
    changeType() {
      this.clearData()
      this.initData()
    },
    // 给重置按钮使用，处理当前页面的逻辑，切换页面有问题
    reset(target, onlyReset) {
      const refs = this.$refs
      // 巡查统计重置功能
      if (target.id === '669-s-2') {
        this.statisticalType = 1
        this.statisticalDataRange = [this.dayjs(new Date().setDate(new Date().getDate() - 10)).format('YYYY-MM-DD'),
          this.dayjs(new Date()).format('YYYY-MM-DD')]
      } else {
        for (const key in refs) {
          const vCom = refs[key][0]
          if (vCom && vCom.reset) {
            vCom.reset()
          }
        }
      }
      // 巡查日志重置功能
      if (target.id === '668-s-8') {
        this.inspectionLogDataRange = [this.dayjs(new Date().setDate(new Date().getDate() - 10)).format('YYYY-MM-DD'),
          this.dayjs(new Date()).format('YYYY-MM-DD')]
      }
      // 考勤日统计-日期重置按钮，显示当前年-月-日
      if (target.id === '1001-s-6') {
        this.clockDay = this.dayjs(new Date()).format('YYYY-MM-DD')
      }
      // 考勤月统计-月份重置按钮，显示当前年-月
      if (target.id === '1002-s-5') {
        this.clockMonth = this.dayjs(new Date()).format('YYYY-MM')
      }
      if (target.id === '120-s-9') {
        this.resetSystemData(target.id)
      }
      if (!onlyReset) {
        this.search(target)
      }
    },
    // 给切换页面使用，根据js处理数据
    asyncReset(curr) {
      if (curr && curr.filters && curr.filters.left) {
        curr.filters.left.forEach((item) => {
          if (['select', 'input', 'data'].includes(item.type)) {
            if (item.dValue) {
              item.value = item.dValue
            } else {
              item.value = undefined
            }
          } else if (item.type === 'dataRange') {
            item.value = undefined
            item.start = undefined
            item.end = undefined
          }
        })
      }
    },
    addGgtzPre(target) {
      const vm = this
      vm.onShowDialogFromTableBtn(null, target)
    },
    addRulePre(target) {
      if (
        target &&
        (target.id === '663-b-1' || target.id === '667-b-1') &&
        this.isAggregation
      ) {
        this.$message.warning('复合区子区域无法添加规则设置，请在复合区添加！')
        return
      }
      this.onShowDialogFromTableBtn(null, target)
    },
    addRule() {
      console.log('addRule', this.$refs)
      const vm = this
      const pid = this.miTableBtn.id
      const data = {}
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          let ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && (value[ikey] || value[ikey] === 0)) {
            if (ikey == '_brandId') {
              ikey = 'brandId'
              data[ikey] = value._brandId
            } else {
              data[ikey] = value[ikey]
            }
          } else {
            if (ikey != 'bikeIdExtractStart' && ikey != 'bikeIdExtractLength') {
              return this.$message.error(
                '请填写' + name.replace(':', '').replace('：', '')
              )
            }
          }
        }
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiPost(data, params, vm.miTableBtn.api)
        .then((res) => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('匹配规则添加成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('addRule', err)
        })
    },
    editRule() {
      const vm = this
      const pid = this.miTableBtn.id
      const data = {
        id: this.rowData.id,
        brandId: this.rowData.brandId
      }
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          const ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && (value[ikey] || value[ikey] === 0)) {
            data[ikey] = value[ikey]
          } else {
            if (ikey != 'bikeIdExtractStart' && ikey != 'bikeIdExtractLength') {
              return this.$message.error(
                '请填写' + name.replace(':', '').replace('：', '')
              )
            } else {
              data[ikey] = 0
            }
          }
        }
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      let url = ''
      if (pid === '663-tb-1') {
        // 扫一扫巡查规则设置修改接口
        url = Api.editRule
      } else if (pid === '667-tb-1') {
        // 嗅探规则设置修改接口
        url = Api.editRuleMac
      } else {
        // 扫一扫巡查车辆二维码地址规则设置修改接口
        url = Api.saveBrandBikeNotUploadPathRule
      }
      url(data, params)
        .then((res) => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('规则修改成功!')
            vm.onCloseDialog()
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('editRule', err)
        })
    },
    numsDetelePre(target) {
      // 批量删除前置校验
      const vm = this
      if (vm.multipleSelection && !vm.multipleSelection.length) {
        return vm.$message.error('请先选择要删除的记录！')
      }
      vm.onShowDialogFromTableBtn(null, target)
    },
    multmatchPre(target) {
      const vm = this
      if (vm.multipleSelection && !vm.multipleSelection.length) {
        return vm.$message.error('请先选择要匹配的车辆！')
      }
      vm.onShowDialogFromTableBtn(null, target)
    },
    multmatch(target) {
      // 批量匹配车企
      if (!this.form.brandId) {
        this.$message.error('请选择车辆品牌')
        return
      }
      let data = {
        bikeIds: this.multipleSelection.map((val) => val.bikeId).join(','),
        brandId: this.form.brandId,
        selfAreaId: this.selfAreaId
      }
      let url = Api.multMatchBrand
      if (target == 'mac') {
        url = Api.multMatchMac
        data = {
          bikeMacs: this.multipleSelection.map((val) => val.bikeMac).join(','),
          brandId: this.form.brandId,
          selfAreaId: this.selfAreaId
        }
      }
      url(data)
        .then((res) => {
          if (res && res.code === 200) {
            this.$message.success('批量匹配成功！')
            this.onCloseDialog(1)
            this.form = {}
            const currTab = this.configJs.find((item) => item.active)
            this.refreshPage(currTab)
          } else {
            this.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('multMatchBrand', err)
        })
    },
    numsDetele(target) {
      if (target == 'bikeNotUpload' || target == 'bikeNotUploadMac') {
        this.bikeDetele(target)
        return
      }
      // 批量删除
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        ids: vm.multipleSelection.join(',')
      }
      vm.postApiPre(data, params, '/api/miApp/deleteReports')
        .then((res) => {
          if (res && res.code === 200) {
            vm.$message.success('违规举报批量删除成功！')
            vm.onCloseDialog()
            // 刷新页面
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('the numsDetele has problem: ', err)
        })
    },
    bikeDetele(type) {
      // 批量删除
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      var url = Api.deleteBikeNot
      var data = {
        bikeIds: vm.multipleSelection.map((val) => val.bikeId).join(',')
      }
      if (type == 'bikeNotUploadMac') {
        url = Api.deleteBikeNotMac
        data = {
          bikeMacs: vm.multipleSelection.map((val) => val.bikeMac).join(',')
        }
      }
      url(data, params)
        .then((res) => {
          if (res && res.code === 200) {
            vm.$message.success('批量删除成功！')
            vm.onCloseDialog()
            // 刷新页面
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('the bikeDetele has problem: ', err)
        })
    },
    onAuditList(target) {
      // 审核列表
      console.log('审核列表', target)
      this.tabChange({
        id: target.tabChangeId
      })
    },
    illegalOperation(target) {
      // 违规类型操作
      // console.log('违规类型操作', target)
      if (target && target.relativeId) {
        this.translateActive(target.relativeId, true, undefined, true)
      }
    },
    changeSearchItem(cp) {
      this.translateValue('filters', 'left', cp)
    },
    tabChange(item) {
      this.translateActive(item.id, true, undefined, true)
    },
    subTabChange(item) {
      if (item && item.relativeId) {
        this.translateActive(item.relativeId, false, true, false)
      } else {
        this.translateSubTabActive(item)
      }
    },
    refreshPage(curr) {
      let params = {}
      params.currentPage = curr.pageNum
      params.pageSize = curr.pageSize
      // curr的children需要作为参数的使用
      // if (curr.children) {
      //   const subTabCurr = curr.children.find(item => item.active)
      //   params[this.subTabName] = subTabCurr.name
      // }
      // 加入search
      if (curr.name === '系统考核') {
        const refs = this.$refs
        for (const key in refs) {
          const vCom = refs[key] ? refs[key][0] : refs[key]
          if (
            vCom &&
            vCom.getValue &&
            (vCom.getValue() || vCom.getValue() === 0)
          ) {
            console.log(vCom.getValue(), 1)
            params = Object.assign(params, vCom.getValue())
          }
        }
        this.resetSystemData(curr.id)
      } else {
        params = Object.assign(params, this.asyncGetSearchParams(curr.id))
      }
      // 考勤日统计-日期传值
      if (curr.id === '1001') {
        const clockDay = new Date(this.clockDay)
        const year = clockDay.getFullYear()
        // 月份需要加1，然后补足两位
        const month = String(clockDay.getMonth() + 1).padStart(2, '0')
        // 获取日期，确保是两位数
        const day = clockDay.getDate().toString().padStart(2, '0')
        const dayDate = `${year}-${month}-${day}`
        params.dateFormat = dayDate
      }
      // 考勤月统计-月份传值
      if (curr.id === '1002') {
        const clockMonth = new Date(this.clockMonth)
        const year = clockMonth.getFullYear()
        // 月份需要加1，然后补足两位
        const month = String(clockMonth.getMonth() + 1).padStart(2, '0')
        const monthDate = `${year}-${month}`
        params.monthDate = monthDate
      }
      // 扫一扫巡查日志、巡查统计
      if (curr.id === '668' || curr.id === '669') {
        const dateRange = curr.id === '668' ? this.inspectionLogDataRange : this.statisticalDataRange
        const { startTime, endTime } = this.getDateRange(dateRange)
        params.inspectionStartTime = startTime
        params.inspectionEndTime = endTime
        if (curr.id === '669') {
          params.statisticalType = this.statisticalType
        }
      }
      this.clearData()
      console.log(params)
      this.initData(params)
    },
    // 数据处理区
    // -修改js的active ,
    // isRefreshSubTab - 是否重置subTab,
    // doRefresh - true:手动刷新
    // doReset - true:表示不重置search参数
    translateActive(id, isRefreshSubTab, doRefresh, doReset) {
      this.cacheCurrTab = JSON.parse(JSON.stringify(this.currTab))
      if (this.cacheCurrTab && this.cacheCurrTab.id === '800' && id === '600') {
        id = '900'
      }
      if (this.cacheCurrTab && this.cacheCurrTab.id === '900' && id === '500') {
        id = '800'
      }
      this.configJs.forEach((item) => (item.active = false))
      const currTab = this.configJs.find((item) => item.id === id)
      currTab.active = true
      // 是否缓存 currTab.cached 为 false 刷新页面
      if (!currTab.cached || !currTab.tableData || doRefresh) {
        currTab.pageNum = 1
        currTab.pageSize = currTab.defaultPageSize
        if (isRefreshSubTab && currTab.children) {
          // 刷新subTab
          // 新增参数，保持按钮的稳定性
          // currTab.children.forEach(item => {
          // item.active = false
          // })
          // currTab.children[index].active = true
        }
        // 刷新filter
        if (doReset) {
          this.asyncReset(currTab)
        }
        this.refreshPage(currTab)
      }
      // 手动清除一些值
      this.clearData()
    },
    clearData() {
      this.multipleSelection = []
      if (
        this.$refs &&
        this.$refs.table &&
        this.$refs.table.$children &&
        this.$refs.table.$children.length
      ) {
        this.$refs.table.$children.forEach(
          (ref) => ref.clearSelection && ref.clearSelection()
        )
      }
    },
    translateSubTabActive(d) {
      const currTab = this.configJs.find((item) => item.id === d.parentId)
      currTab.children.forEach((item) => (item.active = false))
      const subTab = currTab.children.find((item) => item.id === d.id)
      subTab.active = true
      this.translateActive(d.parentId, false, true, false)
    },
    // -修改js的value
    translateValue(ft, st, d) {
      if (ft && st && d) {
        console.log(ft, st, d)
        const currTab = this.configJs.find((item) => item.id === d.parentId)
        const currFilter = currTab[ft][st].find((item) => {
          return item.id === d.id
        })
        this.$set(currFilter, 'value', d.value)
        // 时间区间 单独处理
        if (d.type === 'dataRange') {
          this.$set(currFilter, 'start', d.start)
          this.$set(currFilter, 'end', d.end)
        }
      }
    },
    // 获取全量违规类型
    getReplyTypeList() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiGet(params, '/api/miApp/getReplyTypeList')
        .then((res) => {
          store
            .dispatch('globalVariable/activeSave', {
              key: 'replyTypeList',
              value: res.data
            })
            .then(() => {
              console.log('getReplyTypeList save success!!!')
            })
        })
        .catch((err) => {
          console.log('the getReplyTypeList has problem:', err)
        })
    },
    // 获取全量调度员
    getAllDispatcherList() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiGet(params, '/api/miApp/getAllDispatcherList')
        .then((res) => {
          store
            .dispatch('globalVariable/activeSave', {
              key: 'dispatcherList',
              value: res.data
            })
            .then(() => {
              // console.log('dispatcherList save success!!!')
            })
        })
        .catch((err) => {
          console.log('the getAllDispatcherList has problem:', err)
        })
    },
    showUserInfo(id) {
      console.log('showUserInfo', id)
      const target = this.currTab.ddy
      const row = this.dispatcherList.find((item) => item.id === id)
      this.onShowDialogFromTableBtn(row, target)
    },
    matchAuto(type) {
      // 批量匹配车企
      let data = {
        bikeIds: this.rowData.bikeId,
        brandId: this.form.brandId,
        selfAreaId: this.selfAreaId
      }
      let url = Api.multMatchBrand
      if (type == 'mac') {
        url = Api.multMatchMac
        data = {
          bikeMacs: this.rowData.bikeMac,
          brandId: this.form.brandId,
          selfAreaId: this.selfAreaId
        }
      }
      url(data)
        .then((res) => {
          if (res && res.code === 200) {
            this.onCloseDialog(1)
            this.$message.success('手动匹配成功！')
            this.form = {}
            const currTab = this.configJs.find((item) => item.active)
            this.$nextTick(() => {
              this.refreshPage(currTab)
            })
          } else {
            this.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('multMatchBrand', err)
        })
    },
    onExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-examineDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleCloseExport() {
      this.checkedCities = []
      this.isIndeterminate = true
      this.checkAll = false
      this.$refs['w-examineDialog'].onCloseDialog()
    },
    handleCheckAllChange(val) {
      console.log(val)
      this.checkedCities = val ? this.examineOptions.map((it) => it.key) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.examineOptions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.examineOptions.length
    },
    // 确认导出
    onSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.userId = vm.user.id
      data.export =
        vm.checkedCities && vm.checkedCities.length
          ? vm.checkedCities.sort(compare).join(',')
          : ''
      data.status = 6
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportSysExamineList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 审核
    onAuditExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-auditDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleAuditCloseExport() {
      this.auditCheckedCities = []
      this.auditIsIndeterminate = true
      this.auditCheckAll = false
      this.$refs['w-auditDialog'].onCloseDialog()
    },
    handleAuditCheckAllChange(val) {
      console.log(val)
      this.auditCheckedCities = val ? this.auditOptions.map((it) => it.key) : []
      this.auditIsIndeterminate = false
    },
    handleAuditCheckedChange(value) {
      const checkedCount = value.length
      this.auditCheckAll = checkedCount === this.auditOptions.length
      this.auditIsIndeterminate =
        checkedCount > 0 && checkedCount < this.auditOptions.length
    },
    // 确认导出
    onAuditSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.auditCheckedCities && vm.auditCheckedCities.length
          ? vm.auditCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportCheckList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleAuditCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 画线
    onLineExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-lineDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleLineCloseExport() {
      this.lineCheckedCities = []
      this.lineIsIndeterminate = true
      this.lineCheckAll = false
      this.$refs['w-lineDialog'].onCloseDialog()
    },
    handleLineCheckAllChange(val) {
      console.log(val)
      this.lineCheckedCities = val ? this.lineOptions.map((it) => it.key) : []
      this.lineIsIndeterminate = false
    },
    handleLineCheckedChange(value) {
      const checkedCount = value.length
      this.lineCheckAll = checkedCount === this.lineOptions.length
      this.lineIsIndeterminate =
        checkedCount > 0 && checkedCount < this.lineOptions.length
    },
    // 确认导出
    onLineSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.lineCheckedCities && vm.lineCheckedCities.length
          ? vm.lineCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportLineList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleLineCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 安装
    onInstallExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-installDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleInstallCloseExport() {
      this.installCheckedCities = []
      this.installIsIndeterminate = true
      this.installCheckAll = false
      this.$refs['w-installDialog'].onCloseDialog()
    },
    handleInstallCheckAllChange(val) {
      console.log(val)
      this.installCheckedCities = val ? this.installOptions.map((it) => it.key) : []
      this.installIsIndeterminate = false
    },
    handleInstallCheckedChange(value) {
      const checkedCount = value.length
      this.installCheckAll = checkedCount === this.installOptions.length
      this.installIsIndeterminate =
        checkedCount > 0 && checkedCount < this.installOptions.length
    },
    // 确认导出
    onInstallSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.installCheckedCities && vm.installCheckedCities.length
          ? vm.installCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportInstallList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleInstallCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 已拒绝
    onRejectExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-rejectDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleRejectCloseExport() {
      this.rejectCheckedCities = []
      this.rejectIsIndeterminate = true
      this.rejectCheckAll = false
      this.$refs['w-rejectDialog'].onCloseDialog()
    },
    handleRejectCheckAllChange(val) {
      console.log(val)
      this.rejectCheckedCities = val ? this.rejectOptions.map((it) => it.key) : []
      this.rejectIsIndeterminate = false
    },
    handleRejectCheckedChange(value) {
      const checkedCount = value.length
      this.rejectCheckAll = checkedCount === this.rejectOptions.length
      this.rejectIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rejectOptions.length
    },
    // 确认导出
    onRejectSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.rejectCheckedCities && vm.rejectCheckedCities.length
          ? vm.rejectCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportRejectList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleRejectCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 不可画线
    onNoLineExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-noLineDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleNoLineCloseExport() {
      this.noLineCheckedCities = []
      this.noLineIsIndeterminate = true
      this.noLineCheckAll = false
      this.$refs['w-noLineDialog'].onCloseDialog()
    },
    handleNoLineCheckAllChange(val) {
      console.log(val)
      this.noLineCheckedCities = val ? this.noLineOptions.map((it) => it.key) : []
      this.noLineIsIndeterminate = false
    },
    handleNoLineCheckedChange(value) {
      const checkedCount = value.length
      this.noLineCheckAll = checkedCount === this.noLineOptions.length
      this.noLineIsIndeterminate =
        checkedCount > 0 && checkedCount < this.noLineOptions.length
    },
    // 确认导出
    onNoLineSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.noLineCheckedCities && vm.noLineCheckedCities.length
          ? vm.noLineCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportNoLineList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleNoLineCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 初始化地图
    initMap() {
      _this = this
      map = new AMap.Map('newSiteMap', {
        resizeEnable: true, // 允许缩放
        zoom: 15 // 设置地图的缩放级别，0 - 20
      })
      map.on('click', function (ev) {
        // 触发事件的地理坐标，AMap.LngLat 类型
        var lnglat = ev.lnglat
        console.log('当前选中：', lnglat.getLng(), '----', lnglat.getLat())
        _this.clockSiteLon = lnglat.getLng()
        _this.clockSiteLat = lnglat.getLat()
        // 清除原有marker
        map.clearMap()
        // 创建一个 Marker 实例：
        var marker = new AMap.Marker({
          position: new AMap.LngLat(lnglat.getLng(), lnglat.getLat()) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        // 将创建的点标记添加到已有的地图实例：
        map.add(marker)
      })
    },
    // 新增考勤站点
    addClockSite() {
      this.clockSiteStatus = 1 // 新增考勤站点信息
      this.closeAddClockSite()
      this.dialogAddSiteVisible = true
      const list = this.treeToList(this.areaAll)
      const address = this.getArea(list, this.selfAreaId)
      // 根据地名定位
      AMap.plugin('AMap.Geocoder', function () {
        var geocoder = new AMap.Geocoder()
        geocoder.getLocation(address, async function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 经纬度
            var lng = result.geocodes[0].location.lng
            var lat = result.geocodes[0].location.lat
            console.log('lng', lng, ', lat', lat)
            await _this.queryFictitiousSite()
            console.log(_this.nearBySite, '--vm.nearBySite---')
            _this.nearBySite.forEach((site) => {
              if (site.gpsRail) {
                console.log(site.gpsRail, '----site.gpsRail-----')
                const gps = JSON.parse(site.gpsRail)
                const path2 = []
                for (const b of gps) {
                  path2.push(new AMap.LngLat(b.lon, b.lat))
                }
                map.add(
                  new AMap.Polygon({
                    path: path2,
                    strokeColor: '#FF33FF',
                    strokeWeight: 6,
                    strokeOpacity: 0.2,
                    fillOpacity: 0.4,
                    fillColor: '#1791fc',
                    zIndex: 50
                  })
                )
              }
            })
            map.setCenter(new AMap.LngLat(lng, lat))
          } else {
            console.log('定位失败！')
          }
        })
      })
    },
    closeAddClockSite() {
      // 关闭新建站点弹窗
      this.dialogAddSiteVisible = false
      map.clearMap()
      this.clockSiteName = '' // 创建新站点弹窗的站点名称
      this.clockSiteLon = '' // 创建新站点弹窗的站点经度
      this.clockSiteLat = '' // 创建新站点弹窗的站点纬度
      this.clockBrandId = '' // 创建新站点弹窗的站点经度
    },
    onAddClockSite() {
      if (this.clockSiteName === '') {
        this.$message.warning('请填写考勤站点名称！')
        return
      }
      if (this.clockBrandId === '') {
        this.$message.warning('请选择品牌名称！')
        return
      }
      if (this.clockSiteLat === '' || this.clockSiteLon === '') {
        this.$message.warning('请新增考勤标记点！')
        return
      }
      let params = {}
      if (this.clockSiteStatus === 1) {
        params = {
          areaId: this.selfAreaId,
          brandId: this.clockBrandId,
          clockSiteName: this.clockSiteName,
          clockSiteLon: this.clockSiteLon,
          clockSiteLat: this.clockSiteLat,
          createBy: this.user.id
        }
      } else {
        this.$set(this.clockSiteInfo, 'brandId', this.clockBrandId)
        this.$set(this.clockSiteInfo, 'clockSiteName', this.clockSiteName)
        this.$set(this.clockSiteInfo, 'clockSiteLon', this.clockSiteLon)
        this.$set(this.clockSiteInfo, 'clockSiteLat', this.clockSiteLat)
        this.$set(this.clockSiteInfo, 'updateBy', this.user.id)
        params = this.clockSiteInfo
        console.log(params)
      }
      Api.saveClockSiteInfo(this.selfAreaId, params).then(res => {
        if (res.code === 200) {
          this.initData(this.getSearchParams())
          this.clearDialogClockSite()
          this.clockSiteStatus = 0
          this.$message.success(this.clockSiteStatus === 1 ? '新增成功' : '修改成功')
        } else {
          this.$message.warning(res && res.message)
        }
      }).catch((e) => {
        console.log('操作考勤站点信息异常：', e)
      })
    },
    clearDialogClockSite() {
      this.dialogAddSiteVisible = false
      this.clockSiteName = ''
      this.clockSiteLon = ''
      this.clockSiteLat = ''
      this.clockBrandId = ''
      this.clockSiteInfo = {}
    },
    // 修改考勤站点信息
    onDialogClockSiteTableBtn(row) {
      this.clockSiteStatus = 2 // 新增考勤站点信息
      this.clockSiteInfo = { ...row }
      const map = new AMap.Map('newSiteMap', {
        resizeEnable: true, // 允许缩放
        zoom: 15, // 设置地图的缩放级别，0 - 20
        center: [row.clockSiteLon, row.clockSiteLat],
        viewMode: '2D',
        zoomEnable: true, // 是否可滚轮缩放
        dragEnable: true, // 是否可拖拽
        keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
        showLabel: true,
        expandZoomRange: false,
        pitch: 60, // 3d有效
        showIndoorMap: false
      })
      const marker = new AMap.Marker({
        position: [row.clockSiteLon, row.clockSiteLat],
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
        imageSize: new AMap.Size(26, 34),
        // 设置是否可以拖拽
        draggable: true,
        cursor: 'move',
        anchor: 'center',
        // 设置拖拽效果
        raiseOnDrag: true
      })
      marker.on('dragend', function ({ lnglat }) {
        console.log(lnglat)
        _this.clockSiteLon = lnglat.lng
        _this.clockSiteLat = lnglat.lat
        console.log('移动考勤站点坐标成功', lnglat.lng, lnglat.lat)
        _this.$message.success('移动考勤站点坐标成功')
      })
      marker.setMap(map)
      // 打开考勤站点修改弹窗
      this.clockSiteName = row.clockSiteName
      this.clockSiteLon = row.clockSiteLon
      this.clockSiteLat = row.clockSiteLat
      this.clockBrandId = row.brandId
      this.dialogAddSiteVisible = true
    },
    initClockTrackMap() {
      // 获取到作为地图容器的DOM元素，创建地图实例
      this.clockTrackMap = new AMap.Map('clockTrackMap', { // 设置地图容器id
        resizeEnable: true,
        zoom: 16 // 初始化地图级别
      })
      this.clockTrackMarker = new AMap.Marker({
        position: [108.478935, 34.997761],
        icon: require('@/assets/clock/walk.png'),
        offset: new AMap.Pixel(-13, -26)
      })
      this.clockTrackMap.add(this.clockTrackMarker)
    },
    onDialogClockTrackTableBtn(trackId) {
      const params = {
        selfAreaId: this.selfAreaId,
        id: trackId
      }
      Api.getClockTrackById(params).then((res) => {
        if (res.code === 200) {
          var row = res.data
          // 清除之前绘制的轨迹和marker
          if (this.polyline) {
            this.polyline.setMap(null)
          }
          if (this.clockTrackMarker) {
            this.clockTrackMarker.setMap(null)
          }
          const lineArr = []
          const tolerance = 1 // 设置容差值，根据实际情况调整
          let parsedPoints = JSON.parse(row.realTimeRail)
          // 如果是单个点对象，转为数组
          if (!Array.isArray(parsedPoints)) {
            parsedPoints = [parsedPoints]
          }
          const simplifiedPoints = this.simplifyPath(parsedPoints, tolerance)
          // 安全遍历（并过滤掉无效元素）
          if (Array.isArray(simplifiedPoints)) {
            simplifiedPoints.forEach(item => {
              if (item && typeof item.longitude === 'number') {
                lineArr.push([item.longitude, item.latitude])
              }
            })
          }
          this.lineArr = lineArr
          this.clockTrackMap = new AMap.Map('clockTrackMap', { // 设置地图容器id
            resizeEnable: true,
            viewMode: '2D', // 使用2D视图
            zoomEnable: true, // 地图是否可缩放，默认值为true
            dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
            doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图，默认为true
            zoom: 16, // 初始化地图级别
            center: this.lineArr[0], // 初始化中心点坐标 北京
            showLabel: true,
            expandZoomRange: false,
            showIndoorMap: false
          })
          this.clockTrackMarker = new AMap.Marker({
            position: this.lineArr[0],
            icon: require('@/assets/clock/walk.png'),
            offset: new AMap.Pixel(-10, -34),
            autoRotation: true,
            angle: 0
          })
          const marker = []
          // 创建起点标记点
          const startMarker = new AMap.Marker({
            position: this.lineArr[0],
            icon: require('@/assets/clock/start.png'),
            offset: new AMap.Pixel(-10, -34),
            map: this.clockTrackMap // 将标记添加到地图上
          })
          marker.push(startMarker)
          // 创建终点标记点
          const endMarker = new AMap.Marker({
            position: this.lineArr[this.lineArr.length - 1],
            icon: require('@/assets/clock/end.png'),
            offset: new AMap.Pixel(-10, -34),
            map: this.clockTrackMap // 将标记添加到地图上
          })
          marker.push(endMarker)
          // 考勤打卡标记点
          const clockRail = JSON.parse(row.clockRail)
          if (clockRail) {
            // 判断是对象还是数组
            if (Array.isArray(clockRail) && clockRail.length > 0) {
              clockRail.forEach(item => {
                const clockMarker = this.getCommonClockMarker(item)
                marker.push(clockMarker)
              })
            } else {
              const clockMarker = this.getCommonClockMarker(clockRail)
              marker.push(clockMarker)
            }
          }
          // 车辆调度标记点
          const dispatchRail = JSON.parse(row.dispatchRail)
          if (dispatchRail) {
            if (Array.isArray(dispatchRail) && dispatchRail.length > 0) {
              dispatchRail.forEach(item => {
                const dispatchMarker = this.getCommonDispatchMarker(item)
                marker.push(dispatchMarker)
              })
            } else {
              const dispatchMarker = this.getCommonDispatchMarker(dispatchRail)
              marker.push(dispatchMarker)
            }
          }
          // 站点打卡标记点
          const siteRail = JSON.parse(row.siteRail)
          if (siteRail) {
            if (Array.isArray(siteRail) && siteRail.length > 0) {
              siteRail.forEach(item => {
                const siteClockMarker = this.getCommonSiteClockMarker(item)
                marker.push(siteClockMarker)
              })
            } else {
              const siteClockMarker = this.getCommonSiteClockMarker(siteRail)
              marker.push(siteClockMarker)
            }
          }
          this.clockTrackMap.add(this.clockTrackMarker)
          this.clockTrackMap.add(marker)
          // 绘制轨迹
          this.polyline = new AMap.Polyline({
            path: this.lineArr,
            showDir: true,
            strokeColor: '#28F', // 线颜色
            strokeWeight: 6, // 线宽
            strokeStyle: 'solid' // 线样式
          })
          this.clockTrackMap.add(this.polyline)
          // 走过的路径
          const passedPolyline = new AMap.Polyline({
            strokeColor: '#AF5', // 线颜色
            strokeWeight: 6 // 线宽
          })
          this.clockTrackMap.add(passedPolyline)
          // 监听marker移动
          this.clockTrackMarker.on('moving', (e) => {
            console.log('marker动了', e)
            passedPolyline.setPath(e.passedPath) // 设置路径样式
            this.clockTrackMap.setCenter(e.target.getPosition(), true) // 设置地图中心点
          })
          this.clockTrackUserName = row.name
          this.clockTrackBrandId = row.brandName
          this.clockTrackDate = row.date
          this.dialogClockTrackVisible = true
        }
      })
    },
    simplifyPath(path, tolerance) {
      // 非数组或空数组，直接返回空数组
      if (!Array.isArray(path) || path.length === 0) return []
      // 只有一个点时，直接返回包含该点的数组（不要重复末尾）
      if (path.length === 1) return [path[0]]
      const simplifiedPath = [path[0]] // 保留起点
      for (let i = 1; i < path.length - 1; i++) {
        if (this.getDistance(path[i], path[i + 1]) > tolerance) {
          simplifiedPath.push(path[i])
        }
      }
      simplifiedPath.push(path[path.length - 1]) // 保留终点
      return simplifiedPath
    },
    getDistance(point1, point2) {
      const lat1 = point1.latitude
      const lng1 = point1.longitude
      const lat2 = point2.latitude
      const lng2 = point2.longitude

      const radLat1 = this.rad(lat1)
      const radLat2 = this.rad(lat2)
      const a = radLat1 - radLat2
      const b = this.rad(lng1) - this.rad(lng2)
      let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
      s = s * 6378137 // 地球半径，单位：米
      s = Math.round(s * 10000) / 10000 // 保留两位小数
      return s
    },
    rad(d) {
      return d * Math.PI / 180.0
    },
    // 提取公共的打卡点位
    getCommonClockMarker(item) {
      const clockMarker = new AMap.Marker({
        position: [item.longitude, item.latitude],
        icon: require('@/assets/clock/clock.png'),
        offset: new AMap.Pixel(-12, -38),
        map: this.clockTrackMap // 将标记添加到地图上
      })
      // 添加点击事件监听
      clockMarker.on('click', () => {
        this.showClockMarkerWindow(clockMarker, item)
      })
      return clockMarker
    },
    // 上下班打卡——点击标记点时显示信息窗体
    showClockMarkerWindow(marker, data) {
      const content = `<div>
                        <div class="show_marker_window_div">类型名称：${data.typeName}</div>
                        <div class="show_marker_window_div">创建时间：${data.createTime}</div>
                        <div class="show_marker_window_div">考勤地点：${data.clockAddress}</div>
									     </div>`
      const infoWindow = new AMap.InfoWindow({
        content: content,
        offset: new AMap.Pixel(0, -30)
      })
      infoWindow.open(this.clockTrackMap, marker.getPosition())
    },
    // 提取公共的车辆调度点位
    getCommonDispatchMarker(item) {
      const dispatchMarker = new AMap.Marker({
        position: [item.longitude, item.latitude],
        icon: require('@/assets/clock/dispatch.png'),
        offset: new AMap.Pixel(-13, -40),
        map: this.clockTrackMap // 将标记添加到地图上
      })
      // 添加点击事件监听
      dispatchMarker.on('click', () => {
        this.showDispatchMarkerWindow(dispatchMarker, item)
      })
      return dispatchMarker
    },
    // 调度打卡——点击标记点时显示信息窗体
    showDispatchMarkerWindow(marker, data) {
      const content = `<div>
                        <div class="show_marker_window_div">
                        ${data.bikeId !== undefined ? '车辆编号：' + data.bikeId : '任务编号：' + data.taskId}
                        </div>
                        <div class="show_marker_window_div">类型名称：${data.typeName}</div>
                        <div class="show_marker_window_div">创建时间：${data.createTime}</div>
                        <div class="show_marker_window_div">调度地址：${data.userAddress}</div>
									     </div>`
      const infoWindow = new AMap.InfoWindow({
        content: content,
        offset: new AMap.Pixel(0, -30)
      })
      infoWindow.open(this.clockTrackMap, marker.getPosition())
    },
    // 提取公共的站点打卡点位
    getCommonSiteClockMarker(item) {
      const siteClockMarker = new AMap.Marker({
        position: [item.longitude, item.latitude],
        icon: require('@/assets/clock/site_clock.png'),
        offset: new AMap.Pixel(-13, -30),
        map: this.clockTrackMap // 将标记添加到地图上
      })
      // 添加点击事件监听
      siteClockMarker.on('click', () => {
        this.showSiteClockMarkerWindow(siteClockMarker, item)
      })
      return siteClockMarker
    },
    // 站点打卡——点击标记点时显示信息窗体
    showSiteClockMarkerWindow(marker, data) {
      const img = this.filterMiImage(data.siteClockImg)
      const content = `<div>
                        <div class="show_marker_window_div">创建时间：${data.createTime}</div>
                        <div class="show_marker_window_div">站点地址：${data.siteClockName}</div>
                        <div style="font-size: 14px;font-weight: bold;color: #666666;display: flex; align-items: center;">
                          <span>站点照片：</span>
                          <div id="previewImage">
                            <img src="${img}" style="width: 40px;height: 40px;padding-top: 5px;"/>
                          </div>
                        </div>
									     </div>`
      const infoWindow = new AMap.InfoWindow({
        content: content,
        offset: new AMap.Pixel(0, -30)
      })
      infoWindow.open(this.clockTrackMap, marker.getPosition())
      // 点击图片—预览图片功能
      document.getElementById('previewImage').addEventListener('click', () => {
        this.previewImage(img)
      })
    },
    filterMiImage(url) {
      return filterMiImage(url)
    },
    previewImage(url) {
      const mask = document.createElement('div')
      mask.style.position = 'fixed'
      mask.style.top = 0
      mask.style.left = 0
      mask.style.width = '100%'
      mask.style.height = '100%'
      mask.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
      mask.style.zIndex = 9999

      const imgPreview = document.createElement('img')
      imgPreview.src = url
      imgPreview.style.position = 'fixed'
      imgPreview.style.top = '50%'
      imgPreview.style.left = '50%'
      imgPreview.style.transform = 'translate(-50%, -50%)'
      imgPreview.style.maxWidth = '80%'
      imgPreview.style.maxHeight = '80%'
      imgPreview.style.zIndex = 10000

      mask.appendChild(imgPreview)
      document.body.appendChild(mask)
      mask.addEventListener('click', () => {
        document.body.removeChild(mask)
      })
    },
    closeClockTrack() {
      // 关闭轨迹回放弹窗
      this.dialogClockTrackVisible = false
      this.clockTrackMap.clearMap()
      this.clockTrackUserName = ''
      this.clockTrackBrandId = ''
      this.clockTrackDate = ''
      this.stopAnimation()
    },
    // 开始回放
    startAnimation() {
      AMap.plugin('AMap.MoveAnimation', () => {
        this.clockTrackMap.setZoom(18)
        this.clockTrackMarker.moveAlong(this.lineArr, {
          // 每一段的时长
          duration: this.duration, // 可根据实际采集时间间隔设置
          // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
          autoRotation: false
        })
      })
    },
    // 暂停回放
    pauseAnimation() {
      this.clockTrackMarker.pauseMove()
    },
    // 继续回放
    resumeAnimation() {
      this.clockTrackMarker.resumeMove()
    },
    // 停止回放
    stopAnimation() {
      this.clockTrackMarker.stopMove()
    },
    // 考勤打卡人员设置
    addClockEmployeeConfig() {
      this.$refs.clockPersonSetDialog.addClockEmployeeConfig()
    },
    // 考勤打卡-日统计详细
    onDialogClockStatisticsDayTableBtn(row) {
      this.$refs.clockDayDetailDialog.clockDayDialog(row)
    },
    treeToList(tree, result = []) {
      tree.forEach((node) => {
        result.push(node)
        node.child && this.treeToList(node.child, result)
      })
      return result
    },
    getArea(adds, id) {
      const target = adds.find((item) => item.id === id)
      if (target && target.parentId) {
        const p = adds.find((item) => item.id === target.parentId)
        return p.areaName + target.areaName
      }
      return target.areaName
    },
    async queryFictitiousSite() {
      const vm = this
      const params = {
        source: 1,
        selfAreaId: this.selfAreaId,
        userId: this.user.id,
        currentPage: 1,
        pageSize: 100000
      }
      await Api.getDeviceList(params)
        .then((res) => {
          if (res.code === 200) {
            console.log(res.data.lists, '--res.data.lists---')
            vm.nearBySite = res.data.lists
          }
          vm.tableLoading = false
          vm.calcView()
        })
        .catch((err) => {
          vm.tableLoading = false
          console.log(err)
        })
    },
    // 查看考勤统计月份详情
    onDialogClockStatisticsTableBtn(row, type) {
      if (type === 1 && row.avgWorkHours <= 0) {
        this.$message.warning('当前数据暂无平均工时')
        return
      }
      if (type === 2 && row.workDays <= 0) {
        this.$message.warning('当前数据暂无出勤天数')
        return
      }
      if (type === 3 && row.loseCardNums <= 0) {
        this.$message.warning('当前数据暂无缺卡次数')
        return
      }
      this.clockDialogTableVisible = true
      this.clockTableData = null
      this.clockTotal = 0
      this.getUserClockData(row, type)
    },
    getUserClockData(row, type) {
      const vm = this
      vm.clockTableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.clockFormData.pageNum,
        pageSize: this.clockFormData.pageSize,
        userId: row.userId,
        brandId: row.brandId,
        monthDate: row.monthDate,
        monthType: type
      }
      Api.getUserClockRecordList(params)
        .then(res => {
          vm.clockTableData = res.data.list
          vm.clockTotal = res.data.total
          vm.clockTableLoading = false
          vm.calcView()
        })
    },
    clockPageNoChange(page) {
      this.clockFormData.pageNum = page
      this.getUserClockData()
    },
    clockPageSizeChange(size) {
      this.clockFormData.pageSize = size
      this.getUserClockData()
    }
  },
  components: {
    vButton,
    formButton,
    formData,
    formDataRange,
    formDataTime,
    formDateselect,
    formDataTimeRange,
    formInput,
    formAutocomplete,
    formTextarea,
    formSelect,
    formStatictext,
    formArea,
    formAreaArea,
    formRadio,
    formUpload,
    WDialog,
    WTable,
    vText,
    vTitle,
    vGgContent,
    vGgInfo,
    vSteps,
    vSelect,
    vImage,
    vTable,
    vStatictext,
    clockDialog,
    clockPersonSetDialog,
    inspectionTable,
    inspectionLogExportDialog
  }
}
</script>

<style lang="less">
@import "../../styles/index.less";
@import "./miBicycle.less";
.my_content_box {
  position: relative;
  .my_mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1006;
    background: rgba(0, 0, 0, 0.5);
  }
  .my_new_site_dialog {
    position: fixed;
    padding: 0 30px 0 30px;
    box-sizing: border-box;
    left: 30px;
    right: 30px;
    bottom: 30px;
    top: 30px;
    z-index: 1007;
    background: #fff;
    &_title {
      height: 30px;
      line-height: 30px;
      display: flex;
      justify-content: space-between;
    }
    .right_box {
      position: absolute;
      padding: 10px;
      box-sizing: border-box;
      right: 0;
      top: 30px;
      width: 300px;
      height: calc(100% - 30px);
      background: #fff;
      .right_box_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 20px;
        &_label {
          min-width: 100px;
          text-align: left;
        }

        &_value {
          margin-top: 10px;
        }

        .site_id_area {
          display: flex;
          justify-content: center;
          flex-direction: row;
          align-items: center;

          .site_id_area_front {
            border: 1px solid #dcdfe6;
            height: 28px;
            line-height: 28px;
            box-sizing: border-box;
            border-right: 0;
            padding: 0 10px;
            border-bottom-left-radius: 4px;
            border-top-left-radius: 4px;
          }
        }
      }
    }

    .handle_btns {
      height: 40px;

      line-height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .map_handle_box {
    position: absolute;
    border-radius: 5px;
    right: 50px;
    bottom: 100px;
    width: 124px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    box-sizing: border-box;
    padding: 10px;

    .map_handles {
      margin-top: 10px;

      .map_handle {
        cursor: pointer;
        border-radius: 12px;
        border: 1px solid #1f8ffb;
        color: #1f8ffb;
        padding: 2px 5px;
        text-align: center;
        margin-bottom: 10px;
      }
    }
  }
}
#newSiteMap {
  height: 90%;
}
.handle_btns {
  display: flex;
  flex-direction: column;
  color: #1f8ffb;
  justify-content: center;

  > div {
    cursor: pointer;
  }
}
#clockTrackMap {
  height: 85%;
}
.input-card {
  bottom: 10px; /* 距离底部的距离 */
  right: 10px; /* 距离右侧的距离 */
}
.input-card .btn {
  margin-right: 1.2rem;
  width: 9rem;
}
.input-card .btn:last-child {
  margin-right: 0;
}
.show_marker_window_div {
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
.export-span span {
  white-space: pre-wrap; /* 保留空格和换行 */
}
label {
  white-space: pre-wrap; /* 保留空格和换行 */
}
#app > div > div.main-container > section > div > div.layout.miBcycle > div > div.layout-body.m16.pagination-bg-white > div.table-container > div > div.el-pagination.is-background {
  margin-top: 10px !important;
}
</style>
